import {DateTimeFormatter} from 'js-joda'
import Button from 'material-ui-next/Button/Button'
import Popover from 'material-ui-next/Popover'
import TableCell from 'material-ui-next/Table/TableCell'
import TextField from 'material-ui-next/TextField'
import AppBar from 'material-ui/AppBar'
import IconButton from 'material-ui/IconButton'
import {NavigationMenu} from 'material-ui/svg-icons'
import Table from 'material-ui-next/Table/Table'
import TableBody from 'material-ui-next/Table/TableBody'
import TableHead from 'material-ui-next/Table/TableHead'
import TableRow from 'material-ui-next/Table/TableRow'
import {Target} from 'mdi-material-ui'
import * as R from 'ramda'
import * as React from 'react'
import injectSheet from 'react-jss'
import {url} from '../../App/AuthenticatedRoute'
import {errorMessage} from '../../Data/FormValidation'
import {formatPrice} from '../../Data/NumberHelper'
import {InquiryForList} from '../../Entities/InquiryForList'
import {Footer} from '../../View/Footer'
import {PrintStatus} from '../../View/InquiryStatusDisplay'
import {LinkTableCell} from '../../View/LinkTableCell'
import {PageSize} from '../../View/PageSize'
import {PaginationView} from '../../View/PaginationView'
import {InquiryOverviewAction} from './InquiryOverviewActions'
import {InquiryOverviewState} from './InquiryOverviewState'

const styles = {
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    overviewWrapper: {
        overflowY: 'scroll',
        flex: '1'
    },
    jumpToPopover: {
        padding: '16px'
    },
    popoverFooter: {
        width: '100%',
        padding: '10px 0',
        display: 'flex',
        justifyContent: 'end'
    }
}

interface Properties {
    readonly state: InquiryOverviewState
    readonly dispatch: (action: InquiryOverviewAction) => void
}

const jumpToButtonId = 'jump-to-button'

export const InquiryOverviewView =
    injectSheet<Properties>(styles)(
        ({classes, state, dispatch}) => {
            const jumpToValidationMessage =
                errorMessage(state.jumpToValidation)
            const jumpToMessage =
                jumpToValidationMessage !== '' ?
                    jumpToValidationMessage :
                    state.jumpToError !== null ?
                        state.jumpToError.type === 'BadResponse' &&
                        state.jumpToError.status === 404
                            ? 'ID nicht vorhanden'
                            : 'Netzwerkfehler'
                        : ''
            return (
                <div className={classes.root}>
                    <div className="navigation">
                        <AppBar
                            title="Anfragenübersicht"
                            className="navigation__bar"
                            iconElementLeft={
                                <IconButton
                                    onTouchTap={() =>
                                        dispatch({
                                            type: 'MenuButtonClicked',
                                        })}
                                >
                                    <NavigationMenu/>
                                </IconButton>
                            }
                            iconElementRight={
                                <IconButton
                                    onClick={
                                        () => {
                                            dispatch({
                                                type: 'ToggleJumpTo',
                                                open: true,
                                            })
                                            setTimeout(
                                                () => {
                                                    const jumpToInput =
                                                        document.getElementById('jump-to-input')
                                                    if (jumpToInput !== null) {
                                                        jumpToInput.focus()
                                                    }
                                                }
                                            )
                                        }
                                    }
                                    id={jumpToButtonId}
                                >
                                    <Target/>
                                </IconButton>
                            }
                        />
                    </div>
                    <Popover
                        open={state.jumpToPopoverOpen}
                        anchorEl={
                            document.getElementById(jumpToButtonId) as HTMLElement
                        }
                        anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                        transformOrigin={{horizontal: 'right', vertical: 'top'}}
                        onClose={
                            () =>
                                dispatch({type: 'ToggleJumpTo', open: false})
                        }
                        classes={{paper: classes.jumpToPopover}}
                    >
                        <form
                            onSubmit={
                                event => {
                                    event.preventDefault()
                                    dispatch({type: 'JumpToSubmit'})
                                }
                            }
                        >
                            <TextField
                                value={state.jumpToInput}
                                helperText={jumpToMessage}
                                error={jumpToMessage !== ''}
                                onChange={
                                    event => dispatch({
                                        type: 'JumpToInputChanged',
                                        value: event.currentTarget.value,
                                    })
                                }
                                label="Anfragen-ID"
                                inputProps={{id: 'jump-to-input'}}
                            />
                            <div className={classes.popoverFooter}>
                                <Button
                                    disabled={state.jumpToLoading}
                                    onClick={() => dispatch({type: 'ToggleJumpTo', open: false})}
                                >
                                    Abbrechen
                                </Button>
                                <Button
                                    color="primary"
                                    disabled={state.jumpToLoading}
                                    type="submit"
                                >
                                    Los
                                </Button>
                            </div>
                        </form>
                    </Popover>
                    <div className={`overview ${classes.overviewWrapper}`}>
                        <div className="overview__content">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Anfrage</TableCell>
                                        <TableCell>
                                            Korrekturabzugstatus
                                        </TableCell>
                                        <TableCell>Angebotsstatus</TableCell>
                                        <TableCell>Unternehmen</TableCell>
                                        <TableCell>Beschreibung</TableCell>
                                        <TableCell>erstellt</TableCell>
                                        <TableCell>letzte
                                            Änderung</TableCell>
                                        <TableCell
                                            style={{textAlign: 'right'}}
                                        >
                                            aktuelles Angebot (netto)
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {R.map(
                                        inquiryForList =>
                                            <InquiryTableRow
                                                inquiryForList={inquiryForList}
                                                key={inquiryForList.inquiry.id}
                                            />,
                                        state.inquiriesForList.data,
                                    )}
                                </TableBody>
                            </Table>
                        </div>
                    </div>
                    <Footer>
                        <PageSize
                            itemsPerPage={state.inquiriesForList.pageSection.itemsPerPage}
                            onChange={
                                value => dispatch({
                                    type: 'ItemsPerPageChanged',
                                    value,
                                })
                            }
                        />
                        <PaginationView
                            pagination={state.inquiriesForList}
                            onNavigate={navigation => dispatch({
                                type: 'PaginationNavigation',
                                navigation
                            })}
                        />
                    </Footer>
                </div>
            )
        }
    )

function InquiryTableRow({inquiryForList}: {
    inquiryForList: InquiryForList,
}) {
    const href =
        url({type: 'InquiryDetails', inquiryNumber: inquiryForList.inquiry.inquiryNumber})
    return (
        <TableRow>
            <LinkTableCell href={href}>
                {inquiryForList.inquiry.inquiryNumber}
            </LinkTableCell>
            <LinkTableCell href={href}>
                <PrintStatus
                    inquiryStatus={inquiryForList.inquiry.proofCopyStatus}
                />
            </LinkTableCell>
            <LinkTableCell href={href}>
                <PrintStatus
                    inquiryStatus={inquiryForList.inquiry.offerStatus}
                />
            </LinkTableCell>
            <LinkTableCell href={href}>
                {inquiryForList.company.name1}<br/>
                {inquiryForList.company.name2}
            </LinkTableCell>
            <LinkTableCell href={href}>
                {inquiryForList.inquiry.notes}
            </LinkTableCell>
            <LinkTableCell href={href}>
                {inquiryForList.inquiry.created.format(DateTimeFormatter.ISO_LOCAL_DATE_TIME)}
            </LinkTableCell>
            <LinkTableCell href={href}>
                {inquiryForList.inquiry.updated.format(DateTimeFormatter.ISO_LOCAL_DATE_TIME)}
            </LinkTableCell>
            <LinkTableCell href={href} numeric={true}>
                {formatPrice(inquiryForList.currentOffer)} €
            </LinkTableCell>
        </TableRow>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/InquiryOverview/InquiryOverviewView.tsx